import { Typography, Divider, Grid } from "@mui/material";
import React from "react";
import { AppointmentsData, Participant } from "../../interfaces/interfaces";
import transformDateToDe from "../../../../functions/transformDateToDe";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
const ListTileAppointments = ({
  participant,
}: {
  participant: Participant;
}): React.JSX.Element => {
  return (
    <React.Fragment>
      <Typography
        variant="caption"
        color="initial"
        sx={{
          mt: 2,
        }}
      >
        {`Termine (${participant.appointments.data.length})`}
      </Typography>

      <Divider sx={{ mb: 1 }} />

      {participant.appointments.data.length === 0 ? (
        <Typography variant="body1" color="initial">
          Keine Termine vorhanden
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {participant.appointments.data.map(
            (appointment: AppointmentsData) => (
              <Grid key={appointment.id} item xs={12} md={6}>
                <Typography
                  variant="body1"
                  color="span"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    gap: 1,
                  }}
                >
                  <KeyboardArrowRightOutlinedIcon
                    sx={{
                      color: "primary.main",
                      fontSize: "1.2rem",
                    }}
                  />

                  {`${transformDateToDe(appointment.date)}, ${
                    appointment.timeSlot
                  } Uhr, ${appointment.coachFullName}`}
                </Typography>
              </Grid>
            )
          )}
        </Grid>
      )}
    </React.Fragment>
  );
};

export default ListTileAppointments;
